import { Search } from "lucide-react";
import styles from "./TopHeader.module.css";

const QuickSearchBar = ({ value, onChange, placeholder = "Search properties, users, passes..." }) => {
  return (
    <div className={styles.searchWrap}>
      <Search className={styles.searchIcon} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className={styles.searchInput}
        placeholder={placeholder}
        aria-label="Global search"
      />
    </div>
  );
};

export default QuickSearchBar;
